import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet'

// API
import * as API  from '../../../utils/api'

// Actions
import {
  updateForm,
} from '../../../actions/onboarding';

// Components
import FlashMessage from '../../../components/Global/FlashMessage'

const DEFAULT_FLASH_MESSAGE_STATE = {
  value: "",
  optionalClasses: "",
}

class PlanSelection extends Component {

  state = {
    numberOfSports: '',
    athleteUsername: '',
    couponCode: {
      value: "",
      empty: true,
      hasError: false
    },
    flashMessage: DEFAULT_FLASH_MESSAGE_STATE
  }

  componentDidMount() {
    const {
      maintained_profile,
      participations
    } = this.props.onboarding

    this.setState({
      numberOfSports: participations.length,
      athleteUsername: maintained_profile.username
    })
  }

  continueAsTrialUser(event) {
    event.preventDefault()
    const { user } = this.props
    const { username } = this.props.onboarding.maintained_profile
    const { participations } = this.props.onboarding

    API.addParticipations(user, username, participations).then(response => {
      if (response.errors) {
        this.setState({
          errorMessage: response.errors[0]
        })
      } else {
        this.props.handleFormSubmit(`/${username}`)
      }
    })
  }

  handleCouponChange(newValue) {
    this.setState(state => ({
      ...state,
      couponCode: newValue,
      flashMessage: DEFAULT_FLASH_MESSAGE_STATE,
    }))
  }

  validateCoupon = () =>  {
    const { user } = this.props
    const { couponCode } = this.state

    API.getCoupon(user, couponCode.value).then(response => {
      if (response.errors || response.error) {
        this.setState({
          flashMessage: {
            value: response.error,
            optionalClasses: "error",
          }
        })
      } else {
        const { coupon } = response
        this.props.updateOnboardingForm({ coupon })
        this.props.handleFormChange('sign-up-payment', 'plan-selection')
      }
    })
  }

  continueToNextForm = () => {
    this.props.handleFormChange('sign-up-payment', 'plan-selection')
  }

  render() {
    const {
      appName
    } = this.props

    const {
      couponCode,
      flashMessage,
    } = this.state

    const inlineInput = {
      'width' : '70%'
    }

    return (
      <div className='onboarding-plan-selection'>
        <Helmet>
          <title>{appName} | Plan Selection</title>
        </Helmet>
        <div className="center">
          <h2>14 Day Free Trial</h2>
          <p>Only interested in the free trial?</p>
          <a className='cta cta-small full-width cta-gradient' onClick={(event) => this.continueAsTrialUser(event)}>
            Continue
          </a>
        </div>
        <hr className="or" />
        <h2 className="center">Premier Profile</h2>

        <h3 className="underlined center">
          Do you have a coupon code?
        </h3>
        { flashMessage.value && flashMessage.value.length > 0 &&
          <FlashMessage optionalClasses={flashMessage.optionalClasses}>
            {flashMessage.value}
          </FlashMessage>
        }
        <div
          className={`input-container${couponCode.hasError ? ' error' : ''}`}
        >
          <label htmlFor="couponCode">
            Coupon Code
          </label>
          <input type="text"
            id="couponCode"
            style={inlineInput}
            placeholder="123XYZ"
            value={couponCode.value}
            onChange={event => this.handleCouponChange(
              {
                value: event.target.value,
                hasError: false,
                empty: event.target.value.length > 0 ? false : true
              }
            )}
          />
          <a
            className='cta-inline'
            onClick={this.validateCoupon}
          >
            Apply
          </a>
          { couponCode.hasError &&
            <div className="input-error-message">
            Invalid Coupon Code
            </div>
          }
        </div>
        <a
          className='cta cta-small full-width cta-gradient'
          onClick={this.continueToNextForm}
        >
          Continue Without Coupon
        </a>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    onboarding: state.onboarding,
    user: state.user,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateOnboardingForm: formData => {
      dispatch(updateForm(formData))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PlanSelection)



// WEBPACK FOOTER //
// ./src/screens/Onboarding/Forms/PlanSelection.js